module.exports = __webpack_public_path__ + "img/81.coffee_tea.dfddc736.svg";